module.exports = __webpack_public_path__ + "img/edit.e8518458.svg";